import type { ReactNode } from "react"

import { useTranslations } from "next-intl"

import { CloseIcon } from "@/components/ui/icons"
import { tv } from "@/lib/utils/tv"

const closeButton = tv({
  base: "hit-target text-fg-muted hover:text-fg focus-visible:ring-brand rounded-2x flex shrink-0 items-center justify-center transition-colors focus-visible:ring-2 focus-visible:outline-none",
})

interface CloseButtonProps {
  onClick?: () => void
  className?: string
  "aria-label"?: string
  icon?: ReactNode
}

export const CloseButton = ({ onClick, className, "aria-label": ariaLabel, icon }: CloseButtonProps) => {
  const t = useTranslations("common")
  return (
    <button type="button" aria-label={ariaLabel ?? t("close")} onClick={onClick} className={closeButton({ className })}>
      {icon ?? <CloseIcon size={16} />}
    </button>
  )
}
